(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

  const modal = document.getElementById('sizeGuideModal');
  const closeBtn = document.getElementById('closeSizeGuide');
  const button = document.querySelector('.size-guide-btn');
  const image = document.getElementById('sizeGuideImage');

  if (!modal || !closeBtn || !button || !image) return;

  let scale = 1, startX = 0, startY = 0, originX = 0, originY = 0;
  let isDragging = false, lastX = 0, lastY = 0;

  const updateTransform = () => {
    image.style.transform = `translate(${originX}px, ${originY}px) scale(${scale})`;
  }

  button.addEventListener('click', () => modal.classList.add('show'));
  closeBtn.addEventListener('click', () => {
    modal.classList.remove('show');
    scale = 1; originX = 0; originY = 0; updateTransform();
  });
  window.addEventListener('click', e => { if(e.target === modal) { modal.classList.remove('show'); scale=1; originX=0; originY=0; updateTransform(); }});

  // 鼠标缩放
  image.addEventListener('wheel', e => {
    e.preventDefault();
    const delta = e.deltaY < 0 ? 0.1 : -0.1;
    scale = Math.min(Math.max(0.5, scale + delta), 3);
    updateTransform();
  });

  // 鼠标拖拽
  image.addEventListener('mousedown', e => {
    isDragging = true;
    startX = e.clientX - originX;
    startY = e.clientY - originY;
    image.style.cursor = 'grabbing';
  });
  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    originX = e.clientX - startX;
    originY = e.clientY - startY;
    updateTransform();
  });
  window.addEventListener('mouseup', e => {
    isDragging = false;
    image.style.cursor = 'grab';
  });

  // 手机端拖拽 & 双指缩放
  let lastDistance = null;
  let touchMode = null;
  image.addEventListener('touchstart', e => {
    if(e.touches.length === 1) {
      touchMode = 'drag';
      startX = e.touches[0].clientX - originX;
      startY = e.touches[0].clientY - originY;
    } else if(e.touches.length === 2) {
      touchMode = 'pinch';
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      lastDistance = Math.sqrt(dx*dx + dy*dy);
    }
  });

  image.addEventListener('touchmove', e => {
    e.preventDefault();
    if(touchMode === 'drag' && e.touches.length===1){
      originX = e.touches[0].clientX - startX;
      originY = e.touches[0].clientY - startY;
      updateTransform();
    } else if(touchMode === 'pinch' && e.touches.length===2){
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      const distance = Math.sqrt(dx*dx + dy*dy);
      const delta = distance - lastDistance;
      scale = Math.min(Math.max(0.5, scale + delta/200), 3);
      lastDistance = distance;
      updateTransform();
    }
  });

  image.addEventListener('touchend', e => {
    if(e.touches.length === 0) touchMode = null;
    if(e.touches.length < 2) lastDistance = null;
  });

});
  } catch(e) { console.error(e); }
})();

})();
